// extracted by mini-css-extract-plugin
export default {"cls1":"FBx2fW8zQAzwOYlGYw3k","cls2":"wKVnbiJhcPutKB97Xm9w FBx2fW8zQAzwOYlGYw3k","isPhone":"r9rjnati9cor2Cup7Fq3"};